import { Transaction } from '@castiron/domain';

export const getOpenOrders = (transactions: Transaction[]): Transaction[] => {
  return transactions.filter(
    transaction =>
      (transaction.order.type === 'standard' && transaction.transactionStatus !== 'failed') ||
      (transaction.order.type === 'custom' && transaction.transactionStatus === 'succeeded'),
  );
};
